<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-08-03 14:19:07
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-12-06 14:30:20
 * @FilePath: \music\src\App.vue
 * @Description:
 *
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved.
-->
<template>
    <div class="both">
        <my-header ref="header"></my-header>
        <loginVue></loginVue>
        <!-- <myAsideVue></myAsideVue> -->
        <newAsideVue></newAsideVue>
        <keep-alive :include="['shoppingCart']">
            <router-view ref="router"></router-view>
        </keep-alive>
        <footerVue v-if="$route.name=='home'"></footerVue>
        <div v-if="$route.meta.bothHidden"></div>
        <playMusicVue v-if="$route.meta.isShowPlayMusic"></playMusicVue>
        <SysDailog :show="showSys" title="系统提示" :content="sysType == 1 ? '您得账号已被禁用' : '您的账号已被删除'" confirmTxt="我知道了"
            @sendMsg="goLogin" />
    </div>
</template>

<script>
// import myHeader from '@components/common/header.vue'
import {
    mapState
} from 'vuex'
import myAsideVue from '@/view/aside.vue'
import myHeader from '@/components/home/header.vue'
import footerVue from './components/home/footer.vue'
import loginVue from './components/home/login.vue'
import playMusicVue from './components/home/playMusic.vue'
import SysDailog from '@/components/dialog/SysDailog.vue'
import newAsideVue from './components/home/newAside.vue'

export default {
    name: 'app',
    components: {
        myHeader,
        footerVue,
        loginVue,
        playMusicVue,
        myAsideVue,
        SysDailog,
        newAsideVue
    },
    data() {
        // 这里存放数据
        return {
        }
    },
    // 监听属性 类似于data概念
    computed: {
        ...mapState({
            showSys: state => state.showSys,
            sysType: state => state.sysType,
        })
    },
    mounted() {
        this.$store.commit('setPutOnMusic', {})
        this.$store.commit('setPutOnMusicUrl', '')
        window.addEventListener('load', () => {
            this.$store.commit('updateStillPlay', false)
        })
    },
    // 方法集合
    methods: {
        goLogin(type) {
            this.$store.commit('updateShowSys', false)
            this.$router.push("/home");
            this.$store.commit('setUser', {})
        },
    },
    watch: {
        $route(to, from) {
            if (to.path == '/home') {
                this.$store.commit('updateStillPlay', true)
            }
        },
    }
}
</script>
<style scoped lang="scss">
.both {
    height: 100%;
    min-width: 1280px;
}

.both_box {
    height: 100%;
}

html,
body {
    width: 120rem;
}
</style>
